export default {
  mounted(el, binding) {
    const validatePhone = () => {
      // Получаем регулярное выражение из binding.arg (передается как параметр)
      const regex = binding.value.regex;
      const isValid = regex.test(el.value);

      // Обновляем флаг в компоненте через переданный метод или реактивное свойство
      if (binding.value.callback) {
        binding.value.callback(isValid);
      }

      // Визуальная индикация валидности ввода
      if (!isValid && el.value.length > 0) {
        el.style.borderColor = "red";
      } else {
        el.style.borderColor = "";
      }
    };

    el.addEventListener("input", validatePhone);
  },
};
  